<template>
	<div class="p_box">
		<div class="p_flex home_box p_f_b">
			<div class="p_f_1">
				<div class="p_flex">
					<div class="p_f_1 home_back" @click="goStay">
							<span class="type_size_22 p_flex p_m_t_20 p_m_l_40 subject_white">待做作业</span>
							<div class="divs"><img src="../../../assets/img/wd.png" class="imgs"></div>
					</div>
					<div class="p_f_1 home_back p_m_l_30" @click="goAlready">
							<span class="type_size_22 p_flex p_m_t_20 p_m_l_40 subject_white">已做作业</span>
							<div class="divs"><img src="../../../assets/img/zuoy.png" class="imgs"></div>
					</div>
				</div>
				<div class="p_flex p_m_t_30">
					<div class="p_f_1 home_back" @click="goMistakes">
							<span class="type_size_22 p_flex p_m_t_20 p_m_l_40 subject_white">错题订正</span>
							<div class="divs"><img src="../../../assets/img/cuot.png" class="imgs"></div>
					</div>
					<div class="p_f_1   p_m_l_30">
						<div class="home_back home_stus" @click='show = true'>
								<span class="type_size_22 p_flex  p_m_l_40 subject_white">提问老师</span>
								<div class="divs"><img src="../../../assets/img/微信图片_20211210181825.png" class="imgsf"></div>
						</div>
					</div>
				</div>
			</div>
			<div class="home_news p_m_l_60">
				<span class="p_flex p_m_t_30 p_m_l_30 type_size_22">消息</span>
				<div class="p_m_t_30 p_m_l_30 p_m_r_30 home_center">
					<div v-for="(item, index) in newsData.list" style="cursor:pointer" :key="index" @click="goDeatils(item)">
						<div class="p_flex p_f_a">
							<div class="news_box">
								<img v-if="item.type==1" src="../../../assets/img/orange.png" />
								<img v-else-if="item.type==2" src="../../../assets/img/blue.png" />
								<img v-else src="../../../assets/img/green.png" />
							</div>
							<div class="p_f_1 p_m_l_20">
								<div class="type_size_18">{{item.student?item.student.name:'其他消息'}}</div>
								<div class="one-overflow p_m_t_14 type_size_16 ">
									{{item.student_content}}
								</div>
							</div>
							<div class="p_m_l_20">
								<div>{{item.enquire_date}}</div>
								<div v-if="item.student_unread > 0" class="p_m_t_14 p_flex p_f_e"><el-badge type="danger" :value="item.student_unread" :max="99" class="item"></el-badge></div>
							</div>
						</div>
						<el-divider></el-divider>
					</div>
				</div>
				<div class="home_btn type_size_16 subject_color small_hand" @click="goNewsSt">查看全部</div>
			</div>
		</div>
		<pop-up :show='show' @closes='show = false' @goButton='show = false'></pop-up>
		<div class="footer">
			<a href="javascript:" onClick="window.open('http://beian.miit.gov.cn/')">滇ICP备2021007786号</a>
		</div>
	</div>
</template>

<script>
import PopUp from './commponents/popUp.vue';
export default {
	name: 'Homes',
	components: {
		PopUp
	},
	data() {
		return {
			show:false,
			newsData: { list:[], count:0 },
		};
	},
	mounted() {
		this.getNewsList()
	},
	methods: {
		goDeatils(e){
			if( e.type == 1 || e.type == 2 ){
				this.$router.push({
					path: '/Errors',
					query:{
						id: e.id
					}
				});
			}
			//else if( e.type == 2 ){ this.$router.push('/Students'); }
			else{
			this.$router.push('/Rests');
			}
		},
		getNewsList(){
			this.$request.ajax(this).post('api_student/news_list',{ page:1, limit:3 }).then(res=>{
				this.newsData = res.data
			})
		},

		goStay() {
			this.$router.push('/Stay');
		},
		goAlready(){
			this.$router.push('/Already');
		},
		goNewsSt(){
			this.$router.push('/NewsSt');
		},
		goMistakes(){
			this.$router.push('/Mistakes');
		}
	}
};
</script>

<style lang="scss" scoped>
.divs{
	display:flex;
	justify-content: flex-end;
}
.imgs{
	width:68px;
	height:80px;
	margin:0 40px 0  0;
}
.imgsf{
	width:68px;
	height:80px;
	margin:0 20px 0  0;
}
.home_news {
	position: relative;
	width: 380px;
	height: 580px;
	background: #ffffff;
	opacity: 1;
	border-radius: 10px 10px 0px 0px;
}

.news_box {
	width: 60px;
	height: 60px;
}

>>> .el-badge__content--danger {
	background-color: #f1282e;
	border: none;
}

.home_btn {
	position: absolute;
	bottom: 0;
	left: 0;
	width: 380px;
	height: 62px;
	background: #e2fff2;
	opacity: 1;
	border-radius: 0px;
	text-align: center;
	line-height: 62px;
}

.home_back {
	background: linear-gradient(135deg, #20e18d 0%, #00af63 100%);
	opacity: 1;
	border-radius: 20px;
	height: 160px;
}

.home_center {
	height: 500px;
	overflow-x: hidden;
	overflow-y: scroll;
	text-align: left;
}
.home_center::-webkit-scrollbar {
	display: none;
}
.home_stus {
	width: 230px;
}
.home_stus > span {
	padding-top: 20px;
}
img{
	width: 100%;
	height: 100;
}
.footer{
	display: flex;
	justify-content: center;
	font-size: 16px;
	margin-top: 50px;
}
</style>



// WEBPACK FOOTER //
// src/components/homes/home/index.vue